// The original files remain editable. Everything under CACHE_PREFIX is disposable.
export const MANIFEST_KEY = 'jollyModManifest';
export const CACHE_PREFIX = 'jollyModCache/';
export const PREVIEW_KEY = 'jollyModMenuPortrait';
export const isModFile = key => typeof key === 'string' && key.startsWith('jollymod/');
const stores = new WeakMap();

function transaction(idb, mode, action) {
    if (!stores.has(idb)) stores.set(idb, idb.createStore('keyval-store', 'keyval'));
    return stores.get(idb)(mode, store => new Promise((resolve, reject) => {
        let result;
        store.transaction.oncomplete = () => resolve(result);
        store.transaction.onabort = store.transaction.onerror = () => reject(store.transaction.error || new Error('Mod storage failed'));
        action(store, value => { result = value; });
    }));
}

export async function readModState(idb) {
    const saved = await idb.get(MANIFEST_KEY);
    if (saved?.version === 1 && Array.isArray(saved.keys)) return saved;
    // Upgrade an already installed mod once, without rereading its image blobs.
    return transaction(idb, 'readwrite', (store, done) => {
        store.get(MANIFEST_KEY).onsuccess = event => {
            if (event.target.result?.version === 1) return done(event.target.result);
            store.getAllKeys().onsuccess = event => {
                const state = {version: 1, revision: crypto.randomUUID(), keys: event.target.result.filter(isModFile)};
                store.put(state, MANIFEST_KEY);
                done(state);
            };
        };
    });
}

export function replaceModFiles(idb, entries, sourcePaths = {}) {
    const state = {version: 1, revision: crypto.randomUUID(), keys: entries.map(([key]) => key), sourcePaths};
    // Replacement and cache invalidation commit together. A quota failure leaves
    // the previous mod intact instead of deleting it before the new write fails.
    return transaction(idb, 'readwrite', (store, done) => {
        store.getAllKeys().onsuccess = event => {
            for (const key of event.target.result) {
                if (isModFile(key) || (typeof key === 'string' && key.startsWith(CACHE_PREFIX)) || key === PREVIEW_KEY) store.delete(key);
            }
            for (const [key, blob] of entries) store.put(blob, key);
            store.put(state, MANIFEST_KEY);
            done(state);
        };
    });
}

export function saveModCache(idb, revision, key, value) {
    return transaction(idb, 'readwrite', (store, done) => {
        store.get(MANIFEST_KEY).onsuccess = event => {
            const current = event.target.result?.revision === revision;
            if (current) store.put(value, key);
            done(current);
        };
    });
}

export async function mapLimit(items, limit, action) {
    const results = new Array(items.length);
    let next = 0;
    await Promise.all(Array.from({length: Math.min(limit, items.length)}, async () => {
        while (next < items.length) {
            const index = next++;
            results[index] = await action(items[index], index);
        }
    }));
    return results;
}
